import authMutations from "./mutations";
import authActions from "./actions";

export default {
  namespaced: true,
  state: {
    isLogged: false,
    user: null,
    initials: null,
  },
  getters: {
    isLogged: (state) => state.isLogged,
    getUser: (state) => state.user,
    getInitials: (state) => state.initials,
  },
  mutations: authMutations,
  actions: authActions,
};